import styled, { css } from 'styled-components';
import { getSpace, borderShape, getGridSpans, getTransition } from '../../../stylesheets/tools';

const StyledAccordion = styled.div`
  margin: ${getSpace('m')} 0;

  .accordion__headlines {
    ${getGridSpans('margin-left', { s: 0, m: [1, 'spread'] })}
  }

  .accordion__item {
    ${getGridSpans('width', { s: 13, m: 12 })};
    max-width: 100%;
    position: relative;
    margin: 15px 0;
  }

  .accordion__heading {
    display: block;
    width: 100%;
    cursor: pointer;
    text-align: left;
    background: transparent;
    border: none;
    position: relative;

    ${props =>
      props.theme.siteTheme &&
      css`
        ${borderShape(props.theme.siteTheme.borderColor)}
      `}

    &[aria-selected='true'],
    &[aria-expanded='true'] {
      ${props =>
        props.theme.siteTheme &&
        css`
          ${borderShape(props.theme.siteTheme.borderColor)}
        `}
      &:after {
        position: absolute;
        content: '';
        bottom: 0;
        width: calc(100% - 4px);
        height: 6px;
        left: 2px;
        background: #fff;
      }
    }

    [data-whatinput='mouse'] &,
    [data-whatinput='touch'] & {
      outline: 0;
    }
  }

  .accordion__title-wrapper {
    display: flex;
    align-items: center;
    padding: 20px;
  }

  .accordion__icon {
    position: relative;
    top: -1px;
    content: '';
    width: 12px;
    height: 12px;
    margin-right: 10px;

    span {
      position: absolute;
      top: 5px;
      width: 12px;
      height: 2px;
      background: #000;
      content: '';
      ${getTransition('fadeFast')}

      &:nth-of-type(2) {
        opacity: 0;
      }
    }
  }

  /* FIXED: Targets the icon when the library sets aria-expanded to false */
  .accordion__heading[aria-expanded='false'] .accordion__icon span:nth-of-type(2) {
    transform: rotate(90deg);
    opacity: 1;
  }

  .accordion__panel {
    position: relative;
    width: 100%;
    border-style: solid;
    border-width: 0 2px 2px 2px;
    display: block;
    padding: 20px;
    border-color: #000;

    ${props =>
      props.theme.siteTheme &&
      css`
        border-color: ${props.theme.siteTheme.borderColor};
      `}
    p {
      width: 100%;
      margin: 0;
    }
  }

  .accordion__panel[hidden] {
    display: none;
  }

  @media print {
    .accordion__panel[hidden] {
      display: block;
    }
  }
`;

const StyledAccordionSkeleton = styled.div`
  width: 100%;
  height: 100px;
  background: red;
`;

export { StyledAccordion, StyledAccordionSkeleton };
